"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const moment = require('moment');
const EVENT_STATUS = {
  INIT: '0',
  // 直播未开始
  ON_LIVE: '1',
  // 正在直播
  END: '2',
  // 直播结束，但是没有录像
  VIDEO: '3' // 直播结束，新的会有录像，旧的没有录像
};
const STATUS = (type, langName) => {
  switch (type) {
    case EVENT_STATUS.INIT:
      return langName.upcoming.statusName;
    case EVENT_STATUS.ON_LIVE:
      return langName.ongoing.statusName;
    default:
      return langName.finished.statusName;
  }
};
const createStatusRef = (type, langName) => {
  switch (type) {
    case EVENT_STATUS.INIT:
      return langName.upcoming.btn;
    case EVENT_STATUS.ON_LIVE:
      return langName.ongoing.btn;
    default:
      return langName.finished.btn;
  }
};
const createTypeRef = (status, langName) => {
  return status === '1' ? langName.activityType.onlineName : langName.activityType.offlineName;
};
const createLangRef = {
  jp: '：日本語',
  en: '：English',
  zh: '：普通话',
  'zh-hk': '：粤语',
  ko: '：한국어',
  th: '：ไทย'
};
const extendProps = o => ({
  'report-event': 'click_marketCard',
  'report-ext1': o.btnTxt,
  'report-ext2': o.btnHref
});
const timezoneMap = {
  'UTC-12 IDLW': -12 * 60,
  'UTC-11 MIT': -11 * 60,
  'UTC-10 HST': -10 * 60,
  'UTC-9:30 MSIT': -9.5 * 60,
  'UTC-9 AKST': -9 * 60,
  'UTC-8 PST': -8 * 60,
  'UTC-7 MST': -7 * 60,
  'UTC-6 CST': -6 * 60,
  'UTC-5 EST': -5 * 60,
  'UTC-4 AST': -4 * 60,
  'UTC-3:30 NST': -3.5 * 60,
  'UTC-3 SAT': -3 * 60,
  'UTC-2': -2 * 60,
  'UTC-1 CVT': -1 * 60,
  UTC: 0,
  'UTC+1 CET': 60,
  'UTC+2 EET': 2 * 60,
  'UTC+3 MSK': 3 * 60,
  'UTC+3:30 IRT': 3.5 * 60,
  'UTC+4 META': 4 * 60,
  'UTC+4:30 AFT': 4.5 * 60,
  'UTC+5 METB': 5 * 60,
  'UTC+5:30 IDT': 5.5 * 60,
  'UTC+6 BHT': 6 * 60,
  'UTC+6:30 MRT': 6.5 * 60,
  'UTC+7 IST': 7 * 60,
  'UTC+8 EAT': 8 * 60,
  'UTC+9 FET': 9 * 60,
  'UTC+9:30 ACST': 9.5 * 60,
  'UTC+10 AEST': 10 * 60,
  'UTC+10:30 FAST': 10.5 * 60,
  'UTC+11 VIT': 11 * 60,
  'UTC+11:30 NFT': 11.5 * 60,
  'UTC+12 PSTB': 12 * 60,
  'UTC+12:45 CIT': 12.75 * 60,
  'UTC+13 PSTC': 13 * 60,
  'UTC+14 PSTD': 14 * 60
};
const getTimeStampRelNow = (timeStamp, timeZone) => {
  if (timezoneMap[timeZone] === undefined) {
    return timeStamp;
  }
  let utcOffset = timezoneMap[timeZone] - (0 - new Date().getTimezoneOffset());
  return timeStamp + utcOffset * 60 * 1000;
};
const getTimeInfo = (startOrigTime, endOrigTime, timeOrigZone) => {
  const startTime = getTimeStampRelNow(startOrigTime * 1000, timeOrigZone);
  const endTime = getTimeStampRelNow(endOrigTime * 1000, timeOrigZone);
  const timeZone = timeOrigZone && timeOrigZone.split(' ')[0] || '';
  return {
    startDate: moment(startTime).format('MMM DD, YYYY'),
    startTime: moment(startTime).format('HH:mm'),
    endDate: moment(endTime).format('MMM DD, YYYY'),
    endTime: moment(endTime).format('HH:mm'),
    timeZone
  };
};
const formatEventListData = (listEvent, statusLanguage = {}) => listEvent.map(item => {
  const signTxt = `${createTypeRef(item.eventType, statusLanguage)}${createLangRef[item.lang] || ''}`;
  const timeInfo = getTimeInfo(item.startTime, item.endTime, item.timeZone);
  let timeText = '';
  if (timeInfo.startDate == timeInfo.endDate) {
    timeText = `${timeInfo.startDate} | ${timeInfo.startTime} - ${timeInfo.endTime}  ${timeInfo.timeZone || ''}`;
  } else {
    timeText = `${timeInfo.startDate} ${timeInfo.startTime} - ${timeInfo.endDate}  ${timeInfo.endTime}  ${timeInfo.timeZone || ''}`;
  }
  return {
    title: item.title,
    content: item.description,
    timeText,
    btnTxt: createStatusRef(item.playStatus, statusLanguage),
    btnHref: `/webinar/detail/${item.eventId}`,
    signTxt,
    backgroundUrl: item.coverUrl || '',
    status: STATUS(item.playStatus, statusLanguage),
    extendProps: extendProps({
      btnTxt: createStatusRef(item.playStatus, statusLanguage),
      btnHref: `/webinar/detail/${item.eventId}`
    })
  };
}).filter(item => item.eventId != 16);
var _default = exports.default = formatEventListData;